let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ku4in")).then(() => parcelRequire('dd3Zm'));